import { useEffect, useRef, useState } from "react";
import { BiEdit, BiLogOutCircle, BiUserCheck, BiUserCircle, BiUserPlus } from "react-icons/bi";
import { BsGear } from "react-icons/bs";
import { Link } from "react-router-dom";

const ProfileDropdown = ({ logout }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="header__sc__two__profile flex flex-col"
      ref={dropdownRef}
      style={{ position: "relative" }}
    >
      {/* Avatar */}
      <img
        alt="profile"
        src="/user-avatar.webp"
        style={{ objectPosition: "top", cursor: "pointer" }}
        onClick={() => setOpen((prev) => !prev)}
      />

      {/* Dropdown */}
      {open && (
        <div className="profile-dropdown flex flex-col absolute top-10 bg-white w-[200px] min-h-[50px] border border-[#e5e7eb] shadow-lg p-2 px-3 z-10 items-start rounded-md">
         <Link
            to="/main/profile"
            className="profile-dropdown__item text-black text-sm"
            onClick={() => setOpen(false)}
          >
            <span className="flex flex-row items-center gap-2 justify-center mt-2" > My profile <BiUserCircle className="" /></span>
            
          </Link>

          <Link
            to="/main/profile/edit"
            className="profile-dropdown__item text-black text-sm"
            onClick={() => setOpen(false)}
          >
            <span className="flex flex-row items-center gap-2 justify-center" > Edit profile <BiUserPlus className="" /></span>
            
          </Link>
           <Link
            to="/main/settings/app"
            className="profile-dropdown__item text-black text-sm"
            onClick={() => setOpen(false)}
          >
            <span className="flex flex-row items-center gap-2 justify-center" > Settings <BsGear className="" /></span>
            
          </Link>
          <hr />

          <strong className="flex flex-row items-center gap-2 justify-center text-black text-sm" onClick={logout}> Logout <BiLogOutCircle className="text-red-500" /></strong>
          
          {/* <button
            className="profile-dropdown__item logout"
            onClick={onLogout}
          >
            Logout
          </button> */}
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
